"use strict";
import { LitElement, html } from "lit";
import { STCComponentMixin } from "../../../common/mixins/stc_component_mixin";
export class KioskButton extends STCComponentMixin(LitElement) {
  handleOpenKiosk(e) {
    const openerReadyType = this.dataset.tutorKioskOpenerReady || "tutor_kiosk_ready";
    e.preventDefault();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const kioskUrl = window["new_tutor_kiosk_session_path"]({ time_zone: timeZone });
    const features = "width=1024,height=768,scrollbars=yes,resizable=yes,toolbar=no,directories=no,location=no,menubar=no,status=no,left=50,top=50";
    const kioskWindow = window.open("about:blank", "_blank", features);
    if (!kioskWindow) {
      return false;
    }
    let parentLogoutDone = false;
    let fallbackTimer;
    const triggerParentLogout = () => {
      if (parentLogoutDone) {
        return;
      }
      parentLogoutDone = true;
      if (fallbackTimer !== void 0) {
        clearTimeout(fallbackTimer);
        fallbackTimer = void 0;
      }
      window.removeEventListener("message", onKioskReadyMessage);
      window.location.replace("/sessions/handle_sso_before_kiosk_start");
    };
    const onKioskReadyMessage = (event) => {
      if (event.origin !== window.location.origin) {
        return;
      }
      const data = event.data;
      if (!data || typeof data !== "object" || data.type !== openerReadyType) {
        return;
      }
      if (event.source !== kioskWindow) {
        return;
      }
      triggerParentLogout();
    };
    window.addEventListener("message", onKioskReadyMessage);
    fallbackTimer = window.setTimeout(triggerParentLogout, 6e4);
    kioskWindow.location.href = kioskUrl;
    return false;
  }
  render() {
    return html`
      <hi-button
        class="app_switcher_btn"
        aesthetic="link"
        aria-label="Opens Kiosk, in new window"
        @trigger-ended=${(e) => this.handleOpenKiosk(e)}
      >
        <p>Kiosk</p>
      </hi-button>
    `;
  }
}
customElements.define("stc-kiosk-button", KioskButton);
